import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo, useEffect, useState } from "react";
import styles from "./styles.module.scss";
const CredInput = (props) => {
    const [value, setValue] = useState(props.defaultValue);
    const handleDefaultPhone = () => {
        const num = `${value.substring(0, 3)}-${value.substring(3, 6)}-${value.substring(6, value.length)}`;
        setValue(num);
        props.setValue((prevState) => {
            const prev = prevState;
            prev[props.num] = value;
            return prev;
        });
    };
    useEffect(() => {
        if (props.type.toLowerCase() === "phone") {
            handleDefaultPhone();
        }
    }, []);
    const phoneChangeHandler = (e) => {
        const number = e.currentTarget.value;
        let num = "";
        num = number.length === 3 || number.length === 7 ? number.concat("-") : number;
        setValue(num);
    };
    const emailChangeHandler = (e) => {
        setValue(e.currentTarget.value);
    };
    return (_jsxs("div", { className: styles.input_container, children: [_jsxs("div", { className: styles.spans, children: [_jsx("span", { children: props.label }), props.isOptional && _jsx("span", { style: { fontWeight: 400 }, children: "(Optional)" })] }), _jsx("div", { className: styles.input__inner_container, children: _jsx("input", { type: "text", value: value, maxLength: props.type !== "email" ? 12 : 32, onChange: props.type?.toLowerCase() === "email" ? emailChangeHandler : phoneChangeHandler }) })] }));
};
export default memo(CredInput);
